import { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ProductListingPage from "../../components/ProductListingPage";
import ProductListSkeleton from "../../components/Results/ProductListSkeleton";
import {
  useBreadcrumbUpdates,
  usePageAnalyticsUpdates,
} from "../../components/hooks";
import { createSearchBreadcrumbs } from "../../helpers/createSearchBreadcrumbs";
import { mapBreadcrumbs } from "../../state/modules/category/mapBreadcrumbs";
import { useUpdateRefineParameters } from "../../components/hooks/useUpdateRefineParameters";
import {
  getItemCount,
  hasFacets,
  getPaginationData,
  getSearchTerm,
} from "../../state/modules/search";
import { getError } from "../../state/modules/error";
import { getStoreUrl } from "../../state/modules/config/selectors";
import { getIsLoading } from "../../state/modules/page/selectors";

export const SearchPage = ({
  formatTranslation,
  location,
  topContent = null,
}) => {
  const hasFacetsValue = useSelector(hasFacets);
  const itemCount = useSelector(getItemCount);
  const isLoading = useSelector(getIsLoading);
  const paginationData = useSelector(getPaginationData);
  const searchTerm = useSelector(getSearchTerm);
  const error = useSelector(getError);
  const storeUrl = useSelector(getStoreUrl);

  const page = paginationData?.page;

  useBreadcrumbUpdates(
    mapBreadcrumbs(
      createSearchBreadcrumbs({
        homeTranslation: formatTranslation("plp_web_breadcrumbs_home"),
        homeLink: storeUrl,
        searchTermTranslation: formatTranslation(
          "plp_web_breadcrumbs_search_results_for",
        ),
        searchTerm,
      }),
    ),
  );

  usePageAnalyticsUpdates();

  useUpdateRefineParameters({ searchTerm });

  useEffect(() => {
    if (searchTerm && page) {
      const { initial, max } = page;

      document.title = formatTranslation("plp_web_search_page_title", {
        searchTerm,
        currentPage: initial,
        maxPage: max,
      });
    }
  }, [searchTerm, page, formatTranslation]);

  if (isLoading) {
    return <ProductListSkeleton />;
  }

  return (
    <div>
      <ProductListingPage
        hasFacets={hasFacetsValue}
        itemCount={itemCount}
        paginationData={paginationData}
        error={error}
        searchTerm={searchTerm}
        location={location}
        topContent={topContent}
      />
    </div>
  );
};

SearchPage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  location: PropTypes.object,
  topContent: PropTypes.node,
};

export default SearchPage;
